<template>
    <div class="TextBlock">
        <StyledArticle class="text" :theme-id="themeId">
            <slot />
        </StyledArticle>
    </div>
</template>

<script>
import StyledArticle from '@/modules/course/components/StepRead/StyledArticle';

export default {
    components: { StyledArticle },
    provide() {
        return {
            theme: {
                color: 'red'
            }
        };
    },
    created() {
        this.themeId = 'knowledge';
    }
};
</script>

<style lang="scss" scoped>
.TextBlock {
    padding: 0 2em;
}
@include media('>=mobile') {
    .text {
        font-size: 140%;
    }
}

@include media('<mobile') {
}
</style>
